import getTableHeaders from './getTableHeaders';
import { IMetric } from 'maps/metrics';

export default isSortMetricValid;

/*
 * In BrowseOpus and BrowseRelated when switching the browse entity type between ”Labels” and any other type,
 * results in an invalid combination between the sortMetric and browseEntityType.
 * There are useEffect's in place to change that but it is possible an intermediate fetch is done with the invalid combination.
 * This helper checks if the combination is valid.
 */
function isSortMetricValid(
  browseEntityType: string,
  sortMetric: string,
  tableHeadersType?: string
): boolean {
  const tableHeaders = getTableHeaders(browseEntityType, tableHeadersType);
  const tableHeaderValues = [
    tableHeaders[0].label.match('track|release|album') && 'releaseDate',
    ...tableHeaders.map(
      (header: { label: string; value: string } | IMetric): string => {
        return header.value;
      }
    ),
  ];
  return tableHeaderValues.includes(sortMetric);
}
